import { Duration } from "luxon";

export const toLocaleMinutes = (ms: number) => {
  return Duration.fromMillis(ms).toFormat("m:ss");
};
